import { ClickupIcon } from "#components/ui/ClickupIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const clickupManifest: IntegrationManifest = {
    key: "clickup",
    displayName: "ClickUp",
    nameKey: "channels.clickup",
    descriptionKey: "clickupDescription",
    trayDescriptionKey: "composerTrayDescriptions.clickup",
    cardDescriptionKey: "connectIntegration.descriptions.clickup",
    connectedContentKeys: ["clickupTasks"],
    brandColor: "#7B68EE",
    iconUrl: IconAssets.Clickup,
    iconUrlAlt: IconAssets.ClickupAlt,
    glyph: ClickupIcon,
    channelType: "UserClickupMcp",
    // Remote-MCP citations resolve via customProperties.integrationKey, not a DataSource.
    dataSources: []
};
